/* eslint-disable hubspot-dev/no-declarations */

import { createQueue } from '../helpers/createQueue';
import { MessageTypes } from '../constants/MessageTypes';
const IDENTITY_LISTENER = 'addIdentityListener';

// Analytics isn't available in frame, but some resource scipts we use e.g forms push to queue.
// We proxy these messages up to parent frame where there called on page analytics.
// For tracker callback we mock tracker as used by scripts
// For identity listener we return the three params passed
// If we need more it might be worthwhile including analytics script and setting params on that.

export class ContainerAnalyticsController {
  constructor({
    applicationController
  }) {
    this.trackerCallbacks = createQueue();
    this.identityListenerCallbacks = createQueue();
    this.parentAnalytics = null;
    this.handleAnalyticsRecieved = analytics => {
      this.parentAnalytics = analytics;
      this.flushQueues();
    };
    this.handlePushToHSQ = pushArgs => {
      if (typeof pushArgs === 'function') {
        this.trackerCallbacks.enqueue(pushArgs);
        return;
      }
      if (Array.isArray(pushArgs)) {
        if (pushArgs[0] === IDENTITY_LISTENER && typeof pushArgs[1] === 'function') {
          this.identityListenerCallbacks.enqueue(pushArgs[1]);
        } else {
          this.applicationController.sendMessage({
            type: MessageTypes.PROXY_ANALYTICS,
            payload: {
              analytics: pushArgs
            }
          });
        }
      }
      if (this.parentAnalytics) {
        this.flushQueues();
      }
    };
    window._hsq = window._hsq || [];
    this.applicationController = applicationController;
    this.registerAnalyticsHandler();
    this.proxyHsq();
  }
  registerAnalyticsHandler() {
    this.applicationController.registerHandler(MessageTypes.RECEIVED_ANALYTICS, this.handleAnalyticsRecieved);
  }
  flushQueues() {
    if (!this.parentAnalytics) {
      return;
    }

    // Flush tracker queue
    do {
      const trakcerCallback = this.trackerCallbacks.dequeue();
      if (trakcerCallback) {
        trakcerCallback(this.tracker);
      }
    } while (this.trackerCallbacks.peek());

    // Flush identity queue
    do {
      const identityCallback = this.identityListenerCallbacks.dequeue();
      if (identityCallback) {
        identityCallback(this.parentAnalytics.hstc, this.parentAnalytics.hssc, this.parentAnalytics.hsfp);
      }
    } while (this.identityListenerCallbacks.peek());
  }
  get tracker() {
    if (!this.parentAnalytics) {
      return null;
    }
    return {
      path: this.parentAnalytics.path,
      referrerPath: this.parentAnalytics.referrerPath,
      utk: {
        visitor: this.parentAnalytics.hutk,
        get: () => this.parentAnalytics.hutk
      },
      pageId: this.parentAnalytics.pageId,
      _getFingerprint: () => this.parentAnalytics.hsfp,
      canonicalUrl: this.parentAnalytics.canonicalUrl,
      contentType: this.parentAnalytics.contentType,
      session: {
        get: () => this.parentAnalytics.hssc
      }
    };
  }
  proxyHsq() {
    // @ts-expect-error unkown function
    window._hsq.push = this.handlePushToHSQ;
    window._hsq.forEach(this.handlePushToHSQ);
  }
}